import PropTypes from "prop-types";
import React from "react";
import axios from "axios";
import TriviaForm from "./TriviaForm";

import { toUnderscore } from "../helper/objectKeyConverter";

export class Form extends React.Component {
  onCreate = (trivia) => {
    const { trivializableType, trivializableId, url } = this.props;
    return axios.post(url, { trivia: toUnderscore(Object.assign(trivia, { trivializableType, trivializableId })) })
      .then(({ data: { notice } }) => this.notifyAndReload(notice));
  }

  onUpdate = (trivia) => {
    const { trivializableType, trivializableId, trivia: { id }, url } = this.props;
    return axios.put(`${url}/${id}`, { trivia: toUnderscore(Object.assign(trivia, { trivializableType, trivializableId })) })
      .then(({ data: { notice } }) => this.notifyAndReload(notice));
  }

  notifyAndReload = (notice) => {
    const notificationElement = document.querySelector(".js--notification");
    notificationElement.innerHTML = `<div class="alert alert-success">${notice}</div>`;
    setTimeout(() => { window.Turbolinks.visit(window.location.toString(), { action: "replace" }); }, 800);
  }

  render() {
    const { trivia, categories, edit } = this.props;
    const { bodySerialized, body, category, source = "" } = trivia;
    return (
      <TriviaForm
        onSubmit={edit ? this.onUpdate : this.onCreate}
        bodySerialized={bodySerialized}
        body={body}
        category={category}
        source={source}
        editing={edit}
        categories={Object.values(categories)}
        allowEmptySource
      />
    );
  }
}

Form.propTypes = {
  trivializableType: PropTypes.string.isRequired,
  trivializableId: PropTypes.number.isRequired,
  trivia: PropTypes.object,
  categories: PropTypes.object,
  edit: PropTypes.bool,
  url: PropTypes.string,
};

Form.defaultProps = {
  trivia: {},
  categories: {},
  edit: false,
  url: null,
};

export default Form;
